// extracted by mini-css-extract-plugin
export var picsslide = "index-module--picsslide--rhmI8";
export var slideAnime = "index-module--slideAnime--hL9za";
export var gamingtext = "index-module--gamingtext--LiWO1";
export var gaming = "index-module--gaming--ScDa8";
export var welcometext = "index-module--welcometext--4IAHL";